import Vue from 'vue'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import firebase from 'firebase/app'

import './assets/css/style.css';

import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { db } from '@/db'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// dates
const moment = require('moment')
require('moment/locale/it')
Vue.use(require('vue-moment'), {
    moment
})

Vue.config.productionTip = false
Vue.use(VueAxios, axios)

Vue.mixin({
    data() {
        return {
            isAdmin: false
        }
    },    
    created: async function(){
        const admins = process.env.VUE_APP_ADMINS
        const auth = await firebase.auth().currentUser
        this.isAdmin = auth && admins.includes(auth.email)
    },
    methods: {
        changeLocale(locale) {
            this.$i18n.locale = locale
        },
        navigateTo(page, params) {
            this.$router.push({ name: page, params })
        }, 
        logout() {            
            const vm = this
            firebase.auth().signOut().then(function() {
                vm.$store.commit('LOGOUT')
                vm.$router.push(`login`)
                vm.toasted.info('Hai effettuato il logout con successo')
            }, function(error) {
                vm.toasted.error('Impossibile effettuare il logout')
            });
        }
    }
})

let app
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
firebase.auth().onAuthStateChanged(async user => {    
    if (!app) {
        //wait to get user
        let user = await firebase.auth().currentUser
        app = new Vue({
            store,
            router,
            i18n,
            render: h => h(App)
        }).$mount('#app')
    }
})